import Modal from "./Modal";
import { useTranslation } from "react-i18next";

function ModalInstallExtension({ show, close }) {
  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      close={close}
      className="modal-install-extension"
      action={
        <button className="white" onClick={close}>
          {t("common.cancel")}
        </button>
      }
      title={t("modals.installExtension.title")}
      size="small"
    >
      <div className="flex-center mt-20">
        <div className="center">
          <h4 className="mt-10">{t("modals.installExtension.message")}</h4>
        </div>
        <div className="vertical-align">
          <a
            href={`https://chromewebstore.google.com/detail/lucas-ai/jpmafcgipgehliiecmpphopbmbmonkmg`}
            target="_blank"
            rel="noreferrer"
          >
            <button className="xl-square white flex-center">
              <i className="notranslate material-icons">cloud_download</i>
              {t("modals.installExtension.download")}
            </button>
          </a>
        </div>
      </div>
    </Modal>
  );
}

export default ModalInstallExtension;
